import { render, staticRenderFns } from "./ExtraRawInfo.vue?vue&type=template&id=2c27073f&scoped=true"
import script from "./ExtraRawInfo.vue?vue&type=script&lang=js"
export * from "./ExtraRawInfo.vue?vue&type=script&lang=js"
import style0 from "./ExtraRawInfo.vue?vue&type=style&index=0&id=2c27073f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c27073f",
  null
  
)

export default component.exports